import { init } from '../utils/history';
/**
 * The middleware is only used to initialise the history event listeners atm
 * @param  {Object} store
 * @return {Function}
 */

export function middleware(store, cb) {
  init(store.dispatch, store.getState, cb);
  return function (next) {
    return function (action) {
      return next(action);
    };
  };
}